import { Component, Inject, OnInit } from '@angular/core';
import { ActionDialogData } from '../models/action-dialog-data.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CaseView } from 'src/app/digigov/models/caseview.model';
import { DgActionService } from '../services/dg-action.service';
import { catchError, map } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-dg-reopen',
  templateUrl: './dg-reopen.component.html',
  styleUrls: ['./dg-reopen.component.scss'],
})
export class DgReopenComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ActionDialogData,
    private dialogRef: MatDialogRef<DgReopenComponent>,
    private dgActionService: DgActionService
  ) { }

  onOpen() {
    const caseDataArray = this.data?.selectedData;
    const apiList = [];
    caseDataArray.forEach((data) => {
      const dataForPost = {
        caseID: ((data as CaseView)?.docId || data?.fileId).toString(),
      };
      const api = this.dgActionService.caseReopen(dataForPost).pipe(
        map((r) => !!r),
        catchError((e) => of(false))
      );
      apiList.push(api);
    });
    forkJoin(apiList).subscribe((resArr: boolean[]) => {
      const anySuccess = resArr.some((r) => !!r);
      this.dialogRef.close(anySuccess);
    });
  }
}
